import { get } from './client.js';
import { auth } from '../auth/firebase.js';

/**
 * 經銷商診斷 API client。
 *   - myTenants：可診斷的 tenant 清單（自己 + 旗下 business）
 *   - myTickets / reopenTicket：我的回報（工單）清單與重開
 *   - resetChat：清空 dealer 診斷對話 → 下一句開全新 session
 * 對話送訊息走 useSSEChat → /ivr-builder/api/dealer/tenants/:hostId/chat（SSE）。
 */
export const dealerApi = {
    myTenants: () => get('/api/ivr/saas-admin/dealer-tenants'),

    myTickets: () => get('/api/ivr/saas-admin/my-tickets'),

    reopenTicket: async (ticketId, note) => {
        const idToken = await auth.currentUser?.getIdToken();
        const r = await fetch(`/api/ivr/saas-admin/my-tickets/${encodeURIComponent(ticketId)}/reopen`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note || '' }),
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.error || `${r.status}`);
        return data;
    },

    resetChat: async (hostId) => {
        const idToken = await auth.currentUser?.getIdToken();
        const r = await fetch(`/ivr-builder/api/dealer/tenants/${encodeURIComponent(hostId)}/chat/reset`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${idToken}` },
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.detail || data.error || `${r.status}`);
        return data;
    },
};
